import React from 'react';
import withRoot from '../withRoot';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { CookieBar } from '../components/CookieBar';

const Main = ({ children }: { children: React.ReactElement }) => {
  return (
    <div>
      <Navigation />
      {/* overflow-x: clip (not hidden) so position: sticky keeps working inside */}
      <main style={{ overflowX: 'clip' }}>{children}</main>
      <Footer />
      <CookieBar />
    </div>
  );
};

export default withRoot(Main);
